import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import * as api from './api'
import * as types from './action-types'

export default function* saga() {
  yield takeLatestApiCall(types.EMPLOYER_SHIFT_RATE_TYPES_FETCH_BEGIN, api.fetchEmployerShiftRateTypes)
}
